import { CalendarDays, CalendarRange, Settings2, TrendingUp } from 'lucide-react';
import type { ModuleNav } from '@/components/layout/module-nav';

/**
 * Hotel's navigation.
 *
 * Settings rewrite sellable inventory. The collector's token is its data
 * source's, on Administracja → Źródła danych.
 */
export const HOTEL_NAV: ModuleNav = {
  left: [
    [
      { to: '/hotel', labelKey: 'hotel.nav.today', icon: CalendarDays },
      { to: '/hotel/results', labelKey: 'hotel.nav.results', icon: TrendingUp },
      { to: '/hotel/forward', labelKey: 'hotel.nav.forward', icon: CalendarRange },
    ],
  ],
  right: [
    {
      to: '/hotel/settings',
      labelKey: 'hotel.nav.settings',
      icon: Settings2,
      capability: 'canEditHotelSettings',
    },
  ],
};
